import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import moment from "moment";
import {
  getCoursesByType,
  addAdmissionPageInfo,
  getAdmissionPageInfo,
  updateAdmissionPageInfo,
} from "../../api/admissionApi";
import LoaderSpinner from "../../common/LoaderSpinner";

function ToggleRegistrationForm({ permissions = {}, isSuperAdmin }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    admissionReducer: {
      isCoursesLoading,
      isAdmissionPageInfoLoading,
      isFetchingExistingAdmsnPageInfo,
    } = {},
  } = state;

  const [year, setyear] = useState(moment(new Date()).format("YYYY"));
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [bachelorsList, setbachelorsList] = useState([]);
  const [mastersList, setmastersList] = useState([]);
  const [isExistingDataFound, setisExistingDataFound] = useState(false);
  const [existingData, setexistingData] = useState({});
  const getCourses = (type, scb, ecb) => dispatch(getCoursesByType({ course_type: type }, scb, ecb));
  useEffect(() => {
    getExistingAdmissionPageInfo(year);
  }, []);

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Toggle registration form</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Toggle registration form
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const getExistingAdmissionPageInfo = (val) => {
    const callbacks = {
      successCallback: getAdmissionPageInfoSuccess,
      failureCallback: getAdmissionPageInfoFailure,
    };
    dispatch(getAdmissionPageInfo({ year: val }, callbacks));
  };
  const getAdmissionPageInfoSuccess = (data) => {
    if (data.data?.length > 0) {
      const existingData = data.data[0];
      setisExistingDataFound(true);
      setexistingData(existingData);
      toast.success("Last saved details loaded successfully.");
      setstartDate(existingData.registration_acceptance_time.start);
      setendDate(existingData.registration_acceptance_time.end);
      // const bachelorsInfo = Object.keys(
      //   JSON.parse(existingData.info?.Bachelors)
      // );
      // const mastersInfo = Object.keys(JSON.parse(existingData.info?.Masters));
      // if (bachelorsInfo.length < 1)
        getCourses(
          "Bachelors",
          getBachelorsCoursesSuccess,
          getBachelorsCoursesFailure
        );
      // else setbachelorsList(JSON.parse(existingData.info.Bachelors));
      // if (mastersInfo.length < 1)
        // getCourses(
        //   "Masters",
        //   getMastersCoursesSuccess,
        //   getMastersCoursesFailure
        // );
      // else setmastersList(JSON.parse(existingData.info.Masters));
    } else {
      setisExistingDataFound(false);
      toast.error("No previous info found for " + year);
      if (bachelorsList.length < 1)
        getCourses(
          "Bachelors",
          getBachelorsCoursesSuccess,
          getBachelorsCoursesFailure
        );
    }
  };
  const getAdmissionPageInfoFailure = (errData) => {
    console.log("getAdmissionPageInfoFailure", errData);
    setisExistingDataFound(false);
  };

  const getBachelorsCoursesSuccess = (list) => {
    setbachelorsList(list);
    if (mastersList.length < 1)
      getCourses("Masters", getMastersCoursesSuccess, getMastersCoursesFailure);
  };
  const getBachelorsCoursesFailure = (errData) => {
    alert(
      "No previous bachelors courses found, please add them to avoid registration failures."
    );
  };
  const getMastersCoursesSuccess = (list) => {
    setmastersList(list);
  };
  const getMastersCoursesFailure = (errData) => {
    alert(
      "No previous masters courses found, please add them to avoid registration failures."
    );
  };
  const handleSaveBtnClick = () => {
    if (isExistingDataFound) {
      const payload = {
        before: existingData,
        updatedInfo: {
          year: year,
          info: {
            Bachelors: JSON.stringify(bachelorsList),
            Masters: JSON.stringify(mastersList),
          },
          registration_acceptance_time: {
            start: startDate,
            end: endDate,
          },
        },
      };
      const callbacks = {
        successCallback: updateAdmissionPageInfoSuccess,
        failureCallback: updateAdmissionPageInfoFailure,
      };
      dispatch(
        updateAdmissionPageInfo(payload, callbacks)
      );
    } else {
      const payload = {
        year: year,
        registration_acceptance_time: {
          start: startDate,
          end: endDate,
        },
        info: {
          Bachelors: JSON.stringify(bachelorsList),
          Masters: JSON.stringify(mastersList),
        },
      };
      const callbacks = {
        successCallback: addAdmsnPageInfoSuccessCallback,
        failureCallback: addAdmsnPageInfoFailureCallback,
      };
      dispatch(addAdmissionPageInfo(payload, callbacks));
    }
  };

  const addAdmsnPageInfoSuccessCallback = (data) => {
    toast.success(data.message);
    resetFormValues();
    getExistingAdmissionPageInfo(year);
  };
  const addAdmsnPageInfoFailureCallback = (errData) => {
    toast.error(errData.message);
  };
  const updateAdmissionPageInfoSuccess = (data) => {
    toast.success(data.message);
    resetFormValues();
    getExistingAdmissionPageInfo(year);
  };
  const updateAdmissionPageInfoFailure = (errData) => {
    console.log("updateAdmissionPageInfoFailure", errData);
  };

  const resetFormValues = () => {
    setyear(moment(new Date()).format("YYYY"));
    setstartDate("");
    setendDate("");
  };

  const renderContent = () => {
    return (
      <div className="card">
        <div
          className="card-header"
          style={{ justifyContent: "space-between" }}
        >
          <h3 className="card-title">
            Enable/Disable registration form for students on home page
          </h3>
          {(isCoursesLoading || isFetchingExistingAdmsnPageInfo || isAdmissionPageInfoLoading) &&
            <span>Loading<LoaderSpinner/></span>}
        </div>
        <div className="ml-20">{existingData.registration_acceptance_time && (<label className="text-danger" style={{ fontWeight: "600" }}>
            Registrations for student are acccepted from <span className="text-primary">{moment(existingData.registration_acceptance_time.start).format("DD-MMM-YYYY")}</span> till <span className="text-primary">{moment(existingData.registration_acceptance_time.end).format("DD-MMM-YYYY")}</span>
          </label>)}</div>
        <div className="card-body">
          Select the year you want to save this information for:
          <div className="mt-4 mb-4">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                views={["year"]}
                label="Select Year"
                value={year}
                // maxDate={new Date()}
                onChange={(date) => {
                  setyear(moment(date).format("YYYY"));
                  getExistingAdmissionPageInfo(moment(date).format("YYYY"));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: "15%", outline: "none" }}
                    helperText={null}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          Select the date range in which the registrations will be open/active
          for the students:
          <div className="mt-4">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="From"
                inputFormat="dd MMM yyyy"
                value={startDate}
                onChange={(date) =>
                  setstartDate(moment(date).format("YYYY-MM-DD"))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: "16%", outline: "none", marginRight: "1rem" }}
                    helperText={null}
                  />
                )}
              />
              <DesktopDatePicker
                label="To"
                inputFormat="dd MMM yyyy"
                value={endDate}
                onChange={(date) =>
                  setendDate(moment(date).format("YYYY-MM-DD"))
                }
                minDate={startDate}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: "16%", outline: "none", marginRight: "2rem" }}
                    helperText={null}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{  paddingTop: "20px" }}>
            <button
              disabled={!startDate || !endDate || !year || isCoursesLoading}
              id="search-user-btn"
              className="btn btn-primary col-md-2"
              type="button"
              onClick={handleSaveBtnClick}
            >
              {isFetchingExistingAdmsnPageInfo || isAdmissionPageInfoLoading ? (
                <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
              ) : isExistingDataFound ? (
                "Update"
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (!isSuperAdmin && !permissions.read) {
    return <NoPermission />;
  }
  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

export default ToggleRegistrationForm;
